// 系统版本
export const SYSTEM_VERSION = `v${import.meta.env.VITE_APP_VERSION}`;
